import '.a{display:flex;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { labelAddressBuilder } from '@app/util/helpers'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { pages } from '@app/util/links'
import { RegionalListPlotModel } from 'functions/app/plot/list-regional'
import { InitiativeCard } from '../../card/InitiativeCard'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { Title } from '@app/components/core/typography/Title'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type PlotsContentSectionType = {
  type: 'plots'
  title: string
  titleLevel?: 'H1' | 'H2' | 'H3' | 'H4'
  seeMoreLabel?: string
  seeMoreLink?: string
  items: RegionalListPlotModel[]
}

export const PlotsContentSection = ({
  title,
  titleLevel = 'H4',
  seeMoreLabel,
  seeMoreLink,
  items,
}: PlotsContentSectionType) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  if (items.length === 0) return null

  return (
    <Column alignItems="stretch" gap={0}>
      <AppearItem staggerIndex={0}>
        {seeMoreLink ? (
          <SectionHeader
            title={title}
            titleLevel={titleLevel}
            seeMore={seeMoreLabel ?? t.common.seeMore}
            toRoute={seeMoreLink}
          />
        ) : (
          <Title.Hx title={titleLevel} style={{ marginBottom: '1rem' }}>
            {title}
          </Title.Hx>
        )}
      </AppearItem>
      <div className="a d"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {items.map((plot, index) => (
          <PlotCardItem key={plot.slug} plot={plot} staggerIndex={index + 1} />
        ))}
      </div>
    </Column>
  )
}

const PlotCardItem = ({
  plot,
  staggerIndex,
}: {
  plot: RegionalListPlotModel
  staggerIndex: number
}) => {
  const t = useTranslations().app
  const appearStyle = useAppearStyle(staggerIndex)

  return (
    <InitiativeCard
      to={pages.plot(plot.slug)}
      image={plot.media?.[0] ?? defaultProjectPicture}
      title={plot.name}
      description={plot.description}
      location={labelAddressBuilder(
        plot.location?.address,
        t.common.notSpecified,
        'regionalLocation',
      )}
      tagText={
        t.common.plotApplicationStatus?.[plot.applicationStatus] ??
        plot.applicationStatus
      }
      tagVariant={
        plot.applicationStatus === 'applicationOpen' ? 'success' : 'neutral'
      }
      style={appearStyle}
    />
  )
}
